export default "__VITE_ASSET__d5990109__"